import { FilterableTableInvoices } from "../../../components/TableInvoices/FilterableTableInvoices";
import { INVOICE_STATUSES_DRAFT } from "../../../types";

export const RouteDrafts: React.FC = () => (
  <FilterableTableInvoices
    statuses={INVOICE_STATUSES_DRAFT}
    showDownloadCsv
    emptyState={{ standart: "No draft invoices." }}
  />
);
